/**
 * UI-тексты индексной страницы городов (CitiesPage / lib/page-modules/citiesPage).
 * Только специфика этой страницы; метатексты/H1/каталог/крошки — в namespace `cities`,
 * общие надзаголовки сервис-страниц — в `servicePage`.
 * Интерполируемые строки — функции; русские склонения через ruPlural.
 */
import { ruPlural } from '@/lib/content/declension';

export const citiesPage = {
    en: {
        // Hero CTAs
        heroOpenGuides: 'Open guides',
        heroCompare: 'Compare cities',
        // Catalog (01)
        destinationsTag: (n) => `${n} ${n === 1 ? 'destination' : 'destinations'}`,
        catalogLead:
            'Every destination in the country in one place. Open a detailed guide for each city.',
        // How it works (04)
        howEyebrow: 'How to plan',
        howTitle: 'How to plan your trip',
        howLead:
            'Choose a city, check neighbourhoods and services, then move on to stays, tours or transport.',
        steps: [
            { title: 'Choose a city', description: 'Decide on the kind of trip and the destination.' },
            { title: 'Read the guide', description: 'What to see, when to go and how many days to plan.' },
            { title: 'Build a route', description: 'Connect cities by transport and book your stay.' },
            { title: 'Hit the road', description: 'Save the guide and set off on your trip.' },
        ],
        // Promo codes (05)
        promosTitle: 'Discounts on stays and tours',
        promosLead: 'Current promo codes — tap “Show code” to copy.',
        // FAQ (06)
        faqEyebrow: () => 'Questions & answers',
        faqTitle: 'Popular questions about cities',
        faqLead:
            'Quick answers about choosing a city, routes and where it is best to stay.',
        // Bottom CTA
        ctaEyebrow: 'Choose your destination',
        ctaTitle: (name) => `Build your trip across ${name} — city by city.`,
        ctaBtn: 'Choose a city',
        // Articles (07)
        articlesTitle: 'Articles about cities',
        // Anchors (vertical-specific; common ones use servicePage.anchor.*)
        anchorCities: 'Cities',
        anchorScenarios: 'Where to go',
        anchorCompare: 'Compare',
        anchorHow: 'How to plan',
        // Scenario / region cards
        scenarioDesc: (n) => `${n} ${n === 1 ? 'city' : 'cities'} in this region — open the selection.`,
        scenarioCount: (n) => `${n} ${n === 1 ? 'city' : 'cities'}`,
        // Compare-ledger season labels (derived per region)
        seasonCoast: 'Jun–Sep',
        seasonNorth: 'Year-round · ski',
        seasonDefault: 'May–Oct',
    },
    ru: {
        heroOpenGuides: 'Открыть гайды',
        heroCompare: 'Сравнить города',
        destinationsTag: (n) => `${n} ${ruPlural(n, ['направление', 'направления', 'направлений'])}`,
        catalogLead:
            'Все направления страны в одном месте. Откройте подробный гайд по каждому городу.',
        howEyebrow: 'Инструкция',
        howTitle: 'Как спланировать поездку',
        howLead:
            'Выберите город, проверьте районы и сервисы, затем переходите к жилью, экскурсиям или транспорту.',
        steps: [
            { title: 'Выберите город', description: 'Определитесь с форматом отдыха и направлением.' },
            { title: 'Изучите гайд', description: 'Что посмотреть, когда ехать и сколько дней закладывать.' },
            { title: 'Постройте маршрут', description: 'Свяжите города транспортом и забронируйте жильё.' },
            { title: 'В путь', description: 'Сохраните гайд и отправляйтесь в поездку.' },
        ],
        promosTitle: 'Скидки на жильё и экскурсии',
        promosLead: 'Актуальные промокоды — нажмите «Показать код», чтобы скопировать.',
        faqEyebrow: () => 'Вопросы и ответы',
        faqTitle: 'Популярные вопросы о городах',
        faqLead:
            'Коротко о выборе города, маршрутах и том, где удобнее остановиться.',
        ctaEyebrow: 'Определитесь с направлением',
        ctaTitle: (name) => `Соберите свою поездку в ${name} — город за городом.`,
        ctaBtn: 'Выбрать город',
        articlesTitle: 'Статьи о городах',
        anchorCities: 'Города',
        anchorScenarios: 'Куда поехать',
        anchorCompare: 'Сравнение',
        anchorHow: 'Как спланировать',
        scenarioDesc: (n) =>
            `${n} ${ruPlural(n, ['город', 'города', 'городов'])} в этом регионе — откройте подборку.`,
        scenarioCount: (n) => `${n} ${ruPlural(n, ['город', 'города', 'городов'])}`,
        seasonCoast: 'Июн–Сен',
        seasonNorth: 'Кругл. год · зимой лыжи',
        seasonDefault: 'Май–Окт',
    },
};
